export const meta = {
  title: '服务条款 | CADCraft AI',
  description: '使用 cadcraft.org 及其托管的 CADCraft 网页版的条款。',
  updated_at: '2026-10-20',
};

## 关于本站

cadcraft.org（“本站”）由 CADCraft AI 运营，是关于 CADCraft 的**独立社区指南站**，提供下载与安装指南、与 Autodesk AutoCAD 的功能对比、教程以及托管的 CADCraft 网页版。CADCraft 是由 ArtCraft 团队开发的开源 CAD 应用（[github.com/storytold/cadcraft](https://github.com/storytold/cadcraft)）。本站与 Autodesk, Inc. 及 ArtCraft 团队均无关联。AutoCAD 是 Autodesk, Inc. 的注册商标。

## CADCraft 软件

CADCraft 由其作者以 MIT 或 Apache-2.0 协议授权。无论从 GitHub 下载还是使用我们托管的网页版，你对该软件的使用均受上述协议约束。软件按**“原样”提供，不附带任何形式的担保**。CADCraft 尚处于早期开发阶段，请备份图纸并在依赖结果前进行检查。

## 托管的网页版

为方便使用，我们托管了官方 CADCraft Web 版本的未修改副本。我们可能随时更新、变更或停止托管。免费版的图纸只保存在你的浏览器中；开通 CADCraft 在线版 Pro 后，图纸还会保存到你的账户。无论哪种方式，都请自行保留重要图纸的副本。

## CADCraft 在线版 Pro

CADCraft 在线版 Pro 是本站可选的付费订阅，提供云端功能（云端图纸、历史版本和分享链接）。费用用于我们额外提供的功能和托管服务，而非开源的 CADCraft 软件本身，软件始终免费。

- **计费。** Pro 按月或按年预付，通过我们的支付服务商（PayPal）收取，每个周期结束时自动续费，直到你取消。
- **取消。** 你可以随时在[设置 → 账单](/settings/billing)或你的 PayPal 账户中取消。已付费的周期结束前仍可使用 Pro，之后账户回到免费版。你仍可以打开、下载和删除已保存的云端图纸，只是不能再保存新的。
- **退款。** 如果 Pro 不适合你，请在首次付款后 7 天内发邮件至 [support@cadcraft.org](mailto:support@cadcraft.org)，我们会全额退款。续费不予退款，但你可以在下次续费前取消。
- **变更。** 如果调整价格，我们会在对现有订阅者的下次续费生效前通知。

## 站内内容

指南、教程和对比仅供参考，可能会过时。CADCraft 与 AutoCAD 的价格、功能和文件格式支持可能变化，做决定前请查阅官方信息。

## 合理使用

不得攻击、过载或试图破坏本站，不得以损害本站运行的方式抓取内容，也不得将本站用于非法目的。

## 责任限制

在法律允许的最大范围内，CADCraft AI 不对因使用本站或软件造成的任何间接或后果性损失或数据丢失承担责任。

## 变更与联系

我们可能更新本条款，以上日期为最新版本。如有疑问：[support@cadcraft.org](mailto:support@cadcraft.org)。
